import Swal from 'sweetalert2';
import { Injectable } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {AuthService} from "./auth.service";
@Injectable()
export class ToastService {
constructor(private translate:TranslateService, private authService:AuthService) {
}
    showMessage(msg = 'success', type:'success'|'error'|'info'|'question' = 'success', timer:number=5000, color='info',  htmlMsg?:string) {
        const toast: any = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: timer,
            customClass: { container: 'toast',  popup: `color-${type}` },
        });
        toast.fire({
            icon: type,
            title: this.translate.instant(msg),
            html:htmlMsg,
            padding: '10px 20px',
        });
    }

    alertConfirm(title:string, msg:string){
        const toast: any = Swal.mixin({
            showConfirmButton: true,
            input: 'password',
            showCloseButton:true,
            html:this.translate.instant(msg),
            confirmButtonColor: this.authService.getAgentPrimaryColor(),
            showCancelButton: true,
            icon: 'warning' ,
            validationMessage: this.translate.instant('requiredFields'),
            customClass: { container: 'sweet-alerts' },
        });
      return   toast.fire({
            title: this.translate.instant(title),
            padding: '2em',
            confirmButtonText: this.translate.instant('validation'),
            cancelButtonText: this.translate.instant('Cancel'),
              inputAttributes:{
                  required: true,
              },
            customClass: 'sweet-alerts'
        }).then((e:any)=>{
          console.log('OKAAA', e)
          if (e.value) {
              return e?.value;
          }
      });
    }
}
